import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import styled, { css } from 'styled-components';

import DocumentBrowseCardLink from './DocumentBrowseCardLink';
import { font, themeValue, withSiteTheme } from '../../../../config/css';

const theme = {
  default: css`
    display: block;
    color: ${themeValue('colors', 'tomato')};
    font: ${font('sm', 'md', 'pnb')};
    padding: 0.5rem 0 1rem;

    &:hover {
      color: ${themeValue('colors', 'rust')};
    }
  `,
};

const DocumentBrowseCardCtaSpan = styled.span.attrs({
  className: 'document-browse-card__cta',
})`
  ${withSiteTheme(theme)}
`;

const DocumentBrowseCardCta = ({
  affiliateCode,
  ctaTitle,
  ctaUrl,
  dataAttrs,
  queryParams,
}) => {
  let ctaUrlWithTag;
  if (affiliateCode) {
    const parsedUrl = queryString.parseUrl(ctaUrl);
    // order of prescedence for tag param:
    // 1) query string value
    // 2) affiliate value configured in cms
    // 3) tag value from the ctaUrl
    const affilateTagParam = { tag: affiliateCode };
    let queryStringTagParam = {};
    if (queryParams.tag) {
      queryStringTagParam = { tag: queryParams.tag };
    }
    const params = {
      ...parsedUrl.query,
      ...affilateTagParam,
      ...queryStringTagParam,
    };
    ctaUrlWithTag = `${parsedUrl.url}?${queryString.stringify(params)}`;
  }

  // Use the hard-coded ctaTitle value if there is an external url for amazon, etc
  const ctaTitleText =
    ctaTitle && ctaUrl && dataAttrs['data-type'] !== 'recipes'
      ? ctaTitle
      : 'view';
  const ctaUrlValue = ctaUrlWithTag || ctaUrl;
  let restParams = {};
  if (ctaUrlWithTag || ctaUrl) {
    restParams = {
      rel: 'noopener noreferrer nofollow',
      target: '_blank',
    };
  }

  return (
    <DocumentBrowseCardLink
      {...dataAttrs}
      href={ctaUrlValue}
      title={ctaTitleText}
      {...restParams}
    >
      <DocumentBrowseCardCtaSpan>{ctaTitleText}</DocumentBrowseCardCtaSpan>
    </DocumentBrowseCardLink>
  );
};

DocumentBrowseCardCta.propTypes = {
  affiliateCode: PropTypes.string,
  ctaTitle: PropTypes.string.isRequired,
  ctaUrl: PropTypes.string.isRequired,
  dataAttrs: PropTypes.object.isRequired,
  queryParams: PropTypes.object.isRequired,
};

DocumentBrowseCardCta.defaultProps = {
  affiliateCode: null,
};

export default DocumentBrowseCardCta;
